export default __webpack_public_path__ + "static/media/index-brief.3776bcee.png";